import * as fetch from 'utils/fetch';

export const ServiceChangePassword = {
  changePassword: async (manfrediteEmail: string): Promise<void> => {
    return fetch.post('/api/change-password', {
      email: manfrediteEmail
    });
  }
};
